import { collectionEngineV1 } from '../apis.js';
const req = collectionEngineV1('/agents');
export const listPolicies = async () => {
    // Tolerate the pre-rollout response shape ({ policies: [...] }) during
    // rolling deploys where the API is older than the webapp bundle.
    const res = await req('GET', `/policies`);
    if (Array.isArray(res)) {
        return res;
    }
    if (res != null && Array.isArray(res.policies)) {
        return res.policies;
    }
    return [];
};
export const setPolicy = (toolName, policy) => req('PUT', `/policies/${encodeURIComponent(toolName)}`, {
    body: { policy },
});
export const resetPolicy = (toolName) => req('DELETE', `/policies/${encodeURIComponent(toolName)}`);
//# sourceMappingURL=agent-policies.js.map